export default {
    courses: [],
    course: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/course/state.js